import { useFetch } from '../hooks/useFetch';
export const PaymentModeBadge = () => {
 const { data } = useFetch('/payments/config');
 if (!data || data.mode !== 'test') return null;
 return <p className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm font-semibold text-amber-900" data-testid="payment-test-notice">TEST MODE — checkout is for testing only. No real payment is collected.</p>;
};
